import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faCircleXmark, faMap, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import {
    faArrowDown,
    faArrowRotateRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faGripVertical,
    faList,
    faPencil,
    faPlus,
    faPrint,
    fas,
    faShareNodes,
    faSync
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faMap,
    faCircleXmark,
    faArrowRotateRight,
    faPrint,
    faDownload,
    faGripVertical,
    faPencil,
    fas,
    faList,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faSync,
    faTrashAlt,
    faPlus,
    faShareNodes,
    faArrowDown,
    faCheckCircle
);
